import { useAbsoluteRoot } from 'helpers/urlRoot';
import { usePathFlag } from 'helpers/utils';
import React, { useState } from 'react';

const OrganisationComponent = (props) => {
    const { code, description, longDescription, type } = props;
    const { urlRoot } = useAbsoluteRoot();

    const alignEnd = props?.alignEnd ? 'align-end' : '';
    const hideNoc = props?.hideNoc === undefined ? false : props?.hideNoc;
    const d_flex_flex_row = props.alwaysNoc ? 'd-flex flex-row' : ''
    const d_block_d_md_none = props.alwaysNoc ? "" : "d-block d-md-none";

    const [showNocImage, setShowNocImage] = useState(true);
    const hideNocImg = (event) => {
        setShowNocImage(false);
    };
    const codeNoc = usePathFlag(code)

    return (<>
        <div className={`organisation-container  ${d_flex_flex_row}`}>
            {
                !hideNoc &&
                <div className={`image-container  ${d_block_d_md_none}`}>
                    <div className='flag-container'>
                        {showNocImage ? (
                            <img
                                className='flag-image'
                                aria-hidden="true"
                                src={codeNoc}
                                alt={longDescription}
                                onError={hideNocImg}
                            />
                        ) : ('')}
                    </div>
                    {code}
                </div>
            }
            {props?.onlyShortName ? (
                <div className='competitor-short-name d-inline-block text-truncate'>{description}</div>
            ) : (
                <>
                    <div className={`competitor-long-name d-none  d-sm-block text-truncate`}> {longDescription}</div>
                    <div className='competitor-short-name d-inline-block d-sm-none text-truncate'> {description}</div>
                </>
            )}
        </div>


    </>);

}

//export default Organisation;
export const Organisation = React.memo(OrganisationComponent);

export default Organisation